import React from 'react';

const ConfirmModal = ({ 
  isOpen, 
  onClose, 
  onConfirm, 
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  variant = "warning" // "warning", "danger", "info"
}) => {
  if (!isOpen) return null;

  const variantStyles = {
    warning: {
      icon: "⚠️",
      iconBg: "bg-yellow-500/20",
      iconColor: "text-yellow-400",
      confirmBtn: "bg-yellow-600 hover:bg-yellow-700"
    },
    danger: {
      icon: "🚨",
      iconBg: "bg-red-500/20",
      iconColor: "text-red-400",
      confirmBtn: "bg-red-600 hover:bg-red-700"
    },
    info: {
      icon: "ℹ️",
      iconBg: "bg-blue-500/20",
      iconColor: "text-blue-400",
      confirmBtn: "bg-blue-600 hover:bg-blue-700"
    }
  };

  const style = variantStyles[variant] || variantStyles.warning;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center" data-testid="confirm-modal-overlay">
      {/* Backdrop */}
      <div 
        className="absolute inset-0 bg-black/70 backdrop-blur-sm"
        onClick={onClose}
        data-testid="confirm-modal-backdrop"
      />
      
      {/* Modal */}
      <div className="relative bg-gray-800 rounded-2xl shadow-2xl max-w-md w-full mx-4 overflow-hidden border border-gray-700" data-testid="confirm-modal">
        {/* Header */}
        <div className="p-6 pb-4">
          <div className="flex items-start gap-4">
            <div className={`w-12 h-12 rounded-full ${style.iconBg} flex items-center justify-center flex-shrink-0`}>
              <span className={`text-2xl ${style.iconColor}`}>{style.icon}</span>
            </div>
            <div>
              <h3 className="text-xl font-bold text-white mb-2" data-testid="confirm-modal-title">{title}</h3>
              <p className="text-gray-300 text-sm leading-relaxed whitespace-pre-line" data-testid="confirm-modal-message">
                {message}
              </p>
            </div>
          </div>
        </div>
        
        {/* Footer */}
        <div className="flex gap-3 p-4 bg-gray-900/50 border-t border-gray-700">
          <button
            onClick={onClose}
            className="flex-1 px-4 py-2.5 rounded-lg bg-gray-700 hover:bg-gray-600 text-white font-medium transition-colors"
            data-testid="confirm-modal-cancel-btn"
          >
            {cancelText}
          </button>
          <button
            onClick={async () => {
              await Promise.resolve(onConfirm());
              onClose();
            }}
            className={`flex-1 px-4 py-2.5 rounded-lg ${style.confirmBtn} text-white font-medium transition-colors`}
            data-testid="confirm-modal-confirm-btn"
          >
            {confirmText}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
